// The one place the app's version lives. Bump it (and package.json, which a test
// keeps in step) with each release, and add an entry to src/changelog.js.
export const APP_VERSION = '2.0.0';
